// @ts-nocheck baseline 2026-02-16 - web-only file, moduleSuffixes resolves to native
import { OverviewScreenContent } from "@src/features/cameras/screens/OverviewScreenContent";

/**
 * Alarms tab is mobile-only. On web, redirect to overview.
 */
export default function AlarmsScreen() {
  return <OverviewScreenContent />;
}
